import { charterEmail } from 'untils/constant/email';
import { Phone, Mail } from 'lucide-react';
import ImgDescCard from 'components/ImgDescCard';
import styled from 'styled-components';
import { vw } from 'components/common/Common';

const ContactSection = styled.div`
  width: 100%;
`;

const ContactTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #050a30;
  line-height: normal;
`;

const ContactInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${vw(32)};
  padding: ${vw(20)} 0;
  border-top: 1px solid #dde2e4;
  border-bottom: 1px solid #dde2e4;
  margin-bottom: ${vw(20)};
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${vw(16)};
  font-size: 16px;
  font-weight: 500;
  color: #050a30;
`;

const ContactIcon = styled.img`
  width: ${vw(18)};
  height: ${vw(18)};
`;

const PS = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #07080a;
  line-height: 1.3;
`;
const Contact = () => {
  return (
    <ImgDescCard
      isLeft
      imgSrc="/imgs/webp/jetCard/water.webp"
      imgAlt="view of private jet wing flying over water"
      title="Get your Airacer Jet Card today"
      desc={[
        'Get the jet card that carries you where you need to go in style, comfort, and class.',
      ]}
    >
      <ContactSection>
        <ContactInfo>
          <ContactTitle>Contact your personal concierge today:</ContactTitle>
          <ContactItem>
            <Phone size={18} alt="phone icon" />
            <span>+1 800-213-5051</span>
          </ContactItem>
          <ContactItem>
            <Mail size={18} alt="email icon" />
            <span>{charterEmail}</span>
          </ContactItem>
        </ContactInfo>
        <PS>P.S. Pets fly free!</PS>
      </ContactSection>
    </ImgDescCard>
  );
};

export default Contact;
